module.exports = __webpack_public_path__ + "static/programista_react-b7c167c0d637cc32b9de4748183e4eb1.jpg";